<template lang="pug">
main.modal-wrapper
    svg-icon.close-modal.cursor(
        name='close'
        size="small"
        @click.native="closeModal()"
    )

    spinner.l-flex-row--center.l-align-center(
        width="200"
        height="200"
        v-if="isLoading"
    )

    template(v-else)
        //- ASIDE PANEL
        Panel(panelClassName="modal-information")
            sectionHeader(slot="header" title="details")


            .modal-information-content(slot="content")

                //- Formula Resume
                .modal-info-section.modal-info-section-formula(
                    v-if="mode === 'segment'"
                )
                    h2.l-flex-row--between Formula
                        |
                        .fd-criterion-settings
                            .fd-criterion-setting.long-value(v-if="showFrequency")
                                svg-icon(name='period' size='small' title='Period')
                            .fd-criterion-setting.long-value(v-if="showFrequency")
                                svg-icon(name='frequency' size='small' title='Frequency')
                            .fd-criterion-setting
                                svg-icon(name="calendar" size="small" title="Recency")
                            .fd-criterion-setting(v-if="showQuantile")
                                svg-icon(name="quantile" size="small" title="Quantile")
                            .fd-criterion-setting(v-if="showSurfIntensity")
                                svg-icon(name="target" size="small" title="Surf Intensity")

                    .formula-details
                        div(
                            v-for="(box, index) in audienceFormula.boxes"
                            v-if="!box.isEmpty && !box.disabled"
                            :key="index"
                        )
                            .operator(
                                v-if="box.type != 'inclusive' || index > 0"
                                :class="box.type == 'inclusive' ? 'operator-add' : 'operator-minus'"
                            )
                                svg-icon(
                                    :name="box.type == 'inclusive' ? 'add' : 'minus'"
                                    size="small"
                                )
                            .fd-box
                                criterionSummary(
                                    v-for="(criterion, criterionIndex) of box.criteria"
                                    v-if="!criterion.disabled"
                                    :key="criterionIndex"
                                    :criterion="criterion"
                                )

                //- Volumes Metrics
                .modal-info-section.modal-info-section-metrics(
                    v-if="mode === 'segment'"
                )
                    h2 Metrics
                    Volumes(:volumes="formulaTotalVolumes" :parent="'builder'")

                //- cclone info
                .modal-info-section.modal-info-section-formula(
                    v-if="mode === 'cclone'"
                )
                    h2 Formula
                    .formula-details
                        div(v-if="mode === 'cclone'")
                            div {{ccloneInfo.label}}
                            div {{cclonePointLabel}}

        //- MAIN
        main.modal-main.modal__medium
            header.modal-header
                sectionHeader(:title="modalTitle")

                ul.tabs.l-flex-row
                    li.tab(
                        :class="{'is-active': 'audienceDetails' === activeTab}"
                        @click="setTab('audienceDetails')")
                        .tab-label Audience details
                    li.tab(
                        :class="{'is-active': 'volumeAlert' === activeTab, 'ui-disabled': actionFormAudience === 'edit'}"
                        @click="displayVolumeAlert()")
                        .tab-label Volume alert
                    li.tab(
                        :class="{'is-active': 'audienceTransfer' === activeTab, 'ui-disabled': invalidLabel || totalTransfers >= 10 || actionFormAudience === 'edit' }"
                        @click.prevent="callTransferForm()")
                        .tab-label Audience transfer

            //- FORM CREATE AUDIENCE
            template
                .modal-body.modal-content-audience(v-show="activeTab==='audienceDetails'")

                    //- audience label
                    .form-subsection.mg-tp-24
                        .form-label__required
                            label Label
                        input.form-input(
                            id="audience-name"
                            name="label"
                            placeholder="Choose a nice name for your audience"
                            v-model="audienceForm.label"
                            v-validate="'max:200|required|ascii'"
                            type="text"
                        )
                        span.form-validate-error {{ errors.first('label') }}

                    //- date
                    .form-subsection
                        .form-label__required
                            label End Date
                        el-date-picker(
                            v-model="audienceForm.endDate"
                            name="end_date"
                            editable=true
                            clearable=false
                            class="datepicker"
                            type="date"
                            :picker-options="endDateOptions"
                            value-format="yyyy-MM-dd"
                            v-validate="{ required: true, date_format: 'yyyy-MM-dd' }"
                            @blur="handleResetFieldOnLeave('endDate')"
                            placeholder="Audience end date")
                        span.form-validate-error {{ errors.first('end_date') }}
                        span.form-validate-error(v-if="isEndDateAfterMaxDateLimit") The end date is invalid
                    //.form-subsection.w-180(v-if="!isFirstPartyInFormula")
                        .message-info
                            svg-icon(name='circleInfo' size="large")
                            .message The furthest end date possible is 90 days due to the 3rd party only audience

                    //- email
                    .form-subsection
                        .form-label__required
                            label Email
                        input.form-input(
                            id="email"
                            name="email"
                            placeholder="user@weborama.com"
                            v-model="audienceForm.email"
                            v-validate="'max:255|required|email'"
                            @blur="handleResetFieldOnLeave('email')"
                            type="text"
                        )
                        span.form-validate-error {{ errors.first('email') }}

                    //- cc
                    .form-subsection
                        .form-label.l-flex-row--between
                            label Emails Cc
                            .counter {{ audienceForm.ccList.length }} /10
                        EmailCcField(
                            parent="FormCreateAudience"
                            placeholder="cc@weborama.com"
                            :maxItems="10"
                            :defaultValues="audienceForm.ccList"
                            @formCcListUpdate="updateFormCcList"
                        )


                    //- tags
                    .form-subsection
                        .form-section-info
                            .form-label.l-flex-row--between.l-align-center
                                label Tags
                                .counter {{ tagList.length + ' / ' + maxTagsLimit}}
                            .form-section-subtitle Add tags to group your audience. Tags are limited to 20 characters.

                        .criterion-taglist-wrapper
                            .criterion-taglist.l-flex-row.l-align-center
                                .criterion-tag.l-flex-row.l-align-center(v-for="(tag, tKey) in tagList" :key="tKey")
                                        span.label(:title="tag")  {{ tag }}
                                        svg-icon.cursor(
                                            name='close' size="small"
                                            @click.native="removeTag(tag)")

                                .autocomplete-reference.l-flex-row.l-align-center(v-if="displayTagInput")
                                    input.form-input-tag(
                                        v-model="inputTagValue"
                                        name="tag"
                                        autocomplete="off"
                                        placeholder="+ add tags"
                                        @keyup.enter="handleInputTagConfirm()"
                                        @keyup="debounceLoadTags(inputTagValue, $event)"
                                        @keyup.delete="debounceLoadTags(inputTagValue, $event)"
                                        @keyup.down="navigateAutoComplete(1)"
                                        @keyup.up="navigateAutoComplete(-1)"
                                        @keyup.esc="resetAutoCompleteTag()"
                                        maxlength="20"
                                        v-validate="'max:20'")

                                    //- Auto-complete Tag
                                    .overlay-close_light(
                                        v-if="tagSuggestionList.length >= 1 && inputTagValue.length >= 1"
                                        @click="closeAutoComplete")
                                    ul.autocomplete-list.scrollbar.is-scrollable(
                                        v-if="tagSuggestionList.length >= 1 && inputTagValue.length >= 1"
                                    )
                                        li.autocomplete-item(
                                            v-for="(tagSuggestion, idx) of tagSuggestionList"
                                            :class="{'is-selected': idx === cmpTagListCurrentIndex}"
                                            @click.stop="addTagSuggestion(tagSuggestion)"
                                        ) {{ tagSuggestion }}

                            span.form-validate-error(v-if="displayTagAlert") The tag field may contain alpha-numeric characters as well as dashes and underscores
                            span.form-validate-error.form-validate-error-tag {{ errors.first('tag') }}

                    //- Bootstrap
                    .form-section---bootstrap(v-if="displayBootstrap")
                        .form-label(:class="{ 'ui-disabled': disableBootstrap }")
                            label.flex-1(for="switch-bootstrap") Bootstrap
                            .form-section-subtitle--bootstrap
                                | Search in our DB users matching the audience
                                br
                                | and attribute them the audience.
                        .onoffswitch(:class="{ 'ui-disabled': disableBootstrap }")
                            input(
                                id="switch-bootstrap"
                                name="switch-bootstrap"
                                class="onoffswitch-checkbox"
                                type="checkbox"
                                v-model="bootstrapActivation"
                                true-value="yes"
                                false-value="no"
                                unchecked
                            )
                            label(class="onoffswitch-label" for="switch-bootstrap")
                    .form-validate-error(v-if="displayBootstrap && disableBootstrap") {{ bootstrapWarning }}

                    transition(name="slide-fade")
                        .l-flex-row--center.bootstrap-select(v-if="bootstrapActivation === 'yes'", :class="{ 'ui-disabled': disableBootstrap }")
                            label.form-section-title.flex-1 Bootstrap period
                            select.form-select.select-bootstrap(v-model="audienceForm.bootstrapPeriodSelected", :disabled="disableBootstrap")
                                option(v-for="period of bootstrapPeriodList" v-bind:value="period") {{ `${period} ${period !== 1 ? 'days' : 'day'}` }}

                //- Footer Audience form
                footer.modal-footer(v-show="activeTab==='audienceDetails'")
                    .footer-content.l-flex-row--between
                        button.btn.btn--medium.btn--round(@click="closeModal()") Cancel
                        button.btn.btn--medium.btn--round.btn-rev(
                            :class="{'ui-disabled': disabledSaveButton}"
                            @click="saveAudience()") {{ modalTitle }}

            //- FORM VOLUME ALERT
            FormVolumeAlert(
                v-if="volumeAlertActivation && activeTab==='volumeAlert'"
                parent="builder")

            //- TAB TRANSFERS
            div(v-show="activeTab==='audienceTransfer'")
                .modal-body.modal-content-transfer(v-if="!displayFormCreateTransfer")
                    template(v-if="totalTransfers === 0")
                        p.no-item There is no transfer yet.
                    template(v-else)
                        sectionHeader.transfer-list-header.mg-tp-24(title="Transfers" :counter="totalTransfers")
                        .transfer-type Media Platform
                            ul.transfer-list
                                li.transfer-item.l-flex-row--between(v-for="(mediaTransfer, idx) of transferForms['technology-media']" :key="idx")
                                    span.transfer-label.css-cut-long-text(:title="mediaTransfer.label") {{ mediaTransfer.label }}
                                    .l-flex-row.transfer-item-action
                                        svg-icon(name='edit' size="small" @click.native="editTransfer(mediaTransfer)" title="edit transfer")
                                        svg-icon(name='close' size="small" @click.native="removeTransfer(mediaTransfer,'technology-media')" title="remove transfer")
                        .transfer-wrapper(v-if="totalPixelTransfers > 0")
                            .transfer-type Pixel URL
                        ul.transfer-list
                            li.transfer-item.l-flex-row--between(v-for="(pixelTransfer, idx) of transferForms['technology-pixel']" :key="idx")
                                span.transfer-label.css-cut-long-text(:title="pixelTransfer.label" @click="editTransfer(pixelTransfer)" ) {{ pixelTransfer.label }}
                                .l-flex-row.transfer-item-action
                                    svg-icon(name='edit' size="small" @click.native="editTransfer(pixelTransfer)" title="edit transfer")
                                    svg-icon(name='close' size="small" @click.native="removeTransfer(pixelTransfer,'technology-pixel')" title="remove transfer")

                footer.modal-footer(v-if="!displayFormCreateTransfer")
                    .footer-content.l-flex-row--between
                        button.btn.btn--medium.btn--round(@click="closeModalTransfer()") Cancel
                        button.btn.btn--medium.btn--round.btn-rev(@click="newTransfer()") New transfer


                //- FORM TRANSFER
                FormCreateTransfer(
                    v-else
                    :audienceLabel="audienceForm.label"
                    :audienceEndDate="new Date(audienceForm.endDate)"
                    :isFirstPartyInFormula="isFirstPartyInFormula"
                    parent="builder"
                )
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

import { formatNumber, formatTransferParams, errorHandler, validateTags, getTokenUserEmail } from '@/utils/helpers'

import { uniq, size, isEmpty, last, join, isNil, filter, get, head, concat, reduce, debounce, difference, toNumber } from 'lodash'
import EmailCcField from '@/components/common/EmailCcField'
import Vue from 'vue'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
dayjs.extend(isBetween)

//components
import Panel from '@/components/common/Panel'
import FormCreateTransfer from '@/components/common/FormCreateTransfer'
import FormVolumeAlert from '@/components/common/FormVolumeAlert'
import SectionHeader from '@/components/common/SectionHeader'
import Volumes from '@/components/common/Volumes'
import FormTransfers from '@/components/monitoring/FormTransfers'
import CriterionSummary from '@/components/builder/CriterionSummary'
import Spinner from '@/components/common/Spinner'

export default {
    name: 'FormAudience',

    components: {
        FormCreateTransfer,
        FormVolumeAlert,
        Panel,
        SectionHeader,
        Volumes,
        FormTransfers,
        EmailCcField,
        CriterionSummary,
        Spinner
    },

    props: {
        mode: { type: String, required: true },
        formula: { type: Object, required: false, default: null }
    },

    async created() {
        this.retrieveAttributionCounterAudience()
        if (this.actionFormAudience === 'edit') {
            this.audienceForm.label = this.audienceInEdition.label
            this.audienceForm.endDate = this.audienceInEdition.endDate
            this.audienceForm.email = this.audienceInEdition.email
            this.audienceForm.ccList = this.audienceInEdition.cc ? this.audienceInEdition.cc.split(',') : []
            this.tagList = this.audienceInEdition?.tags?.map(t => t.label) ?? []
            this.bootstrapActivation = this.audienceInEdition.bootstrap === 'attribute' ? 'yes' : 'no'
            if (this.bootstrapActivation === 'yes') {
                this.audienceForm.bootstrapPeriodSelected = this.audienceInEdition.bootstrapPeriod
            }
            await this.$nextTick()
            this.$validator.validateAll()
        }
    },

    data() {
        return {
            audienceForm: {
                label: '',
                endDate: dayjs().format('YYYY-MM-DD'),
                email: getTokenUserEmail(Vue.prototype.$keycloak),
                ccList: [],
                bootstrapPeriodSelected: null
            },
            audienceFormHistory: {
                label: '',
                endDate: dayjs().format('YYYY-MM-DD'),
                email: getTokenUserEmail(Vue.prototype.$keycloak),
                ccList: [],
                bootstrapPeriodSelected: null
            },
            inputCcValue: '',
            tagList: [],
            tagSuggestionList: [],
            tagListCurrentIndex: -1,
            selectedSuggestionTags: [],
            inputTagValue: '',
            currentSelectedTag: '',
            bootstrapActivation: 'no',
            creatingTag: false,
            processing: false,
            maxTagsLimit: 50
        }
    },

    mounted() {
        if (!this.audienceForm.bootstrapPeriodSelected) {
            this.audienceForm.bootstrapPeriodSelected = this.lastBootstrapPeriodAvailable
        }
    },

    watch: {
        tagList: {
            handler: function(val) {
                if (size(val) >= this.maxTagsLimit) {
                    last(document.getElementsByClassName('form-input-tag')).blur()
                }
            }
        },
        transferEndDate: {
            handler: function(value) {
                const transferEndDate = dayjs(value).valueOf()
                const audienceEndDate = dayjs(this.audienceForm.endDate).valueOf()
                if (transferEndDate > audienceEndDate) {
                    this.audienceForm.endDate = dayjs(value).format('YYYY-MM-DD')
                }
            }
        },
        activeTabFormAudience: {
            handler() {
                this.$validator.validateAll()
            }
        }
    },

    computed: {
        ...mapState('account', {
            accountId: state => state.accountId,
            countryCode2: state => state.country.code2,
            attributionCounterAudience: state => state.attributionCounterAudience,
            dailyBootstrapLimit: state => state.dailyBootstrapLimit,
            userRole: state => state.userRole
        }),

        ...mapState('ui/cclone', {
            formulaTotalCcloneVolumes: state => state.formulaVolumes
        }),

        ...mapState('builder', {
            formulaTotalBuilderVolumes: state => state.formulaGlobalVolume,
            audienceFormula: state => state.formula
        }),

        ...mapState('ui/builder', {
            activeTabFormAudience: state => state.formAudience.activeTabFormAudience,
            actionFormAudience: state => state.formAudience.action,
            ccloneFormula: state => state.formula.cclone
        }),

        ...mapState('ui/cclone', {
            selectedCcloneId: state => state.selectedCcloneId
        }),

        ...mapState('ui/volumeAlert', {
            volumeAlertForm: state => state.form,
            volumeAlertActivation: state => state.showForm
        }),

        ...mapState('ui/transfers', {
            transferForms: state => state.forms,
            showFormCreateTransfer: state => state.showFormCreateTransfer,
            transferEndDate: state => state.endDate
        }),

        ...mapState('data/cclone', {
            cclonePointLabel: state => state.selectedPointLabel
        }),

        ...mapState('data/settings', {
            showFrequency: state => state.general.frequency,
            bootstrapPush: state => state.general.bootstrapPush,
            showSurfIntensity: state => state.general.surfintensity,
            showQuantile: state => state.general.quantile
        }),

        // Call mapGetters
        ...mapGetters('ui/builder', ['getFirstPartyInFormula', 'getCrmCriteria', 'getIsFormulaThirdPartyOnly']),
        ...mapGetters('builder', {
            audienceInEdition: 'audienceInEditionFromLegacyList'
        }),

        ...mapGetters('account', ['getUserAccess']),
        ...mapGetters('data/cclone', ['getItemById']),

        isLoading() {
            return this.formulaTotalVolumes === null
        },

        bootstrapWarning() {
            if (this.formulaTotalVolumes.error) return 'The feature is currently unavailable.'
            else if (this.getIsFormulaThirdPartyOnly()) return 'Bootstrap is not available because audience contains 3rd Party only'
            else if (this.actionFormAudience === 'edit' && this.audienceInEdition.bootstrap !== 'none')
                return 'Audience has already been bootstraped. You are not authorized to change it.'
            else return 'The account daily quota has been reached or would be exceeded. Bootstrap will be available when the quota is reset.'
        },

        displayBootstrap() {
            if (this.userRole === 'webo_admin') return true
            if (this.mode === 'cclone') {
                if (!this.bootstrapPush) return false
                if (this.userRole === 'webo_user' && this.getUserAccess({ type: 'cclone_access' }) !== 'write') {
                    return false
                }
                return true
            }
            if (this.userRole === 'webo_employee' && this.bootstrapPush) return true
            return this.bootstrapPush && this.formula?.hasFirstParty
        },

        formulaTotalVolumes() {
            return this.mode == 'cclone' ? this.formulaTotalCcloneVolumes : this.formulaTotalBuilderVolumes
        },

        disableBootstrap() {
            // if (this.formulaTotalVolumes?.error) return true
            if (this.actionFormAudience === 'edit' && this.audienceInEdition.bootstrap !== 'none') return true
            if (this.userRole === 'webo_admin') return false
            return this.attributionCounterAudience + this.formulaTotalVolumes.total_doc >= this.dailyBootstrapLimit || this.getIsFormulaThirdPartyOnly()
        },

        modalTitle() {
            return this.actionFormAudience === 'create' ? 'create audience' : 'edit audience'
        },

        totalVolume() {
            return this.formulaTotalVolumes !== null ? formatNumber(this.formulaTotalVolumes.total_desktop) : null
        },

        emptyLabel() {
            return isEmpty(this.audienceForm.label)
        },

        bootstrapPeriodList() {
            if (this.mode === 'segment') {
                const range = Array(this.hasAcriterionWithExtendedRecency ? 30 : this.maxRecencyAvailable)
                    .fill(1)
                    .map((n, i) => n + i)
                return this.hasAcriterionWithExtendedRecency ? [...range, 395] : range
            }
            return [...Array(30).keys()].map(day => day + 1)
        },

        maxRecencyAvailable() {
            let values = []
            const audienceFormula = { ...this.audienceFormula }
            audienceFormula.boxes.forEach(box => {
                const recencies = box.criteria.map(criteria => {
                    if (criteria.disabled) return 1
                    const { frequencyPeriod, recency } = criteria
                    if (frequencyPeriod && frequencyPeriod.value && !recency.value) {
                        recency.value = 30
                    }
                    return criteria.recency.value
                })
                values = [...values, ...recencies]
            })
            return Math.max(...values)
        },

        hasAcriterionWithExtendedRecency() {
            if (this.mode === 'cclone') return false
            return this.audienceFormula.boxes.some(box => box.criteria.some(c => c.recency.value === 395 && !c.disabled))
        },

        //TRANSFER
        displayFormCreateTransfer() {
            return this.showFormCreateTransfer
        },

        totalPixelTransfers() {
            return size(this.transferForms['technology-pixel'])
        },

        totalMediaTransfers() {
            return size(this.transferForms['technology-media'])
        },

        totalTransfers() {
            return this.totalPixelTransfers + this.totalMediaTransfers
        },

        //TAGS
        displayTagInput() {
            return this.tagList.length < this.maxTagsLimit
        },

        displayTagAlert() {
            if (!this.inputTagValue) return false
            const arrayTag = uniq(this.inputTagValue.split(/[\s,;\t\n]+/))
            return !validateTags(arrayTag)
        },

        launchTagsCreation() {
            return !isEmpty(this.tagList)
        },

        cmpTagListCurrentIndex() {
            return this.tagListCurrentIndex
        },

        cmpTagListCurrentLabel() {
            return head(filter(this.tagSuggestionList, (tag, index) => index === this.cmpTagListCurrentIndex))
        },

        //VOLUME ALERT
        hasVolumeAlert() {
            return !isEmpty(this.volumeAlertForm) && this.actionFormAudience === 'create'
        },

        volumeAlertCc() {
            return !isEmpty(this.volumeAlertForm.email_cc_audience_limit)
        },

        volumeAlertBelowLimit() {
            return this.volumeAlertForm.below_limit !== '' && !isNil(this.volumeAlertForm.below_limit)
        },

        volumeAlertAboveLimit() {
            return this.volumeAlertForm.above_limit !== '' && !isNil(this.volumeAlertForm.above_limit)
        },

        //OTHER
        minDateLimit() {
            return dayjs()
                .startOf('day')
                .valueOf()
        },

        maxDateLimit() {
            return dayjs()
                .startOf('day')
                .add(395, 'days')
                .valueOf()
        },

        isFirstPartyInFormula() {
            let isFirstPartyInFormula = false
            if (this.mode === 'segment') {
                isFirstPartyInFormula = this.formula._boxes.some(box => box._criteria.some(criteria => criteria._type === 'firstParty' && !criteria._disabled))
            }
            return isFirstPartyInFormula || this.mode === 'cclone'
        },

        endDateOptions() {
            return {
                firstDayOfWeek: 1,
                disabledDate: time => {
                    return (
                        this.minDateLimit >
                            dayjs(time)
                                .startOf('day')
                                .valueOf() || dayjs(time).valueOf() >= this.maxDateLimit
                    )
                }
            }
        },

        isEndDateAfterMaxDateLimit() {
            return dayjs(this.audienceForm.endDate).isAfter(dayjs(this.maxDateLimit))
        },

        hasDisabledCriterion() {
            if (this.mode === 'cclone') return false
            return this.audienceFormula.boxes.some(box => box.criteria.some(c => c.disabled))
        },

        invalidLabel() {
            return this.audienceForm.label === '' || this.errors.has('label')
        },

        invalidEnDate() {
            return isNil(this.audienceForm.endDate) || this.errors.has('end_date')
        },

        invalidEmail() {
            return this.audienceForm.email === '' || this.errors.has('email')
        },

        disabledSaveButton() {
            return this.invalidLabel || this.invalidEnDate || this.invalidEmail || this.processing || this.isEndDateAfterMaxDateLimit
        },

        // Tabs navigationcomputed
        activeTab() {
            return this.activeTabFormAudience
        },

        ccloneInfo() {
            return this.getItemById({ id: this.selectedCcloneId })
        },

        disableNewTransfer() {
            return this.totalTransfers > 9
        },

        lastBootstrapPeriodAvailable() {
            return toNumber(last(this.bootstrapPeriodList))
        }
    },

    methods: {
        // Call mapActions
        ...mapActions('ui/builder', ['requestAccountTags', 'closeAudienceForm']),
        ...mapActions('data/transfer', ['createTransfer']),
        ...mapActions('data/audience', ['createAudience', 'editAudience', 'addNewAudienceTags', 'retrieveItems', 'deleteTagFromAudience']),
        ...mapActions('account', ['retrieveAttributionCounterAudience']),
        ...mapActions('dashboardAccount', ['retrieveExpiringAudiences', 'retrieveExpiringTransfers']),

        // Call mapMutations
        ...mapMutations('ui/transfers', ['setShowFormCreateTransfer', 'setTransferForm', 'setTransferInEdition', 'setIsEditTransfer']),
        ...mapMutations('notifications', ['setAddedNotification']),
        ...mapMutations('ui/volumeAlert', ['setShowVolumeAlertForm', 'setIsEditVolumeAlert', 'setDefaultVolumeAlertForm']),
        ...mapMutations('ui/builder', ['setActiveTabFormAudience']),
        ...mapMutations('builder', ['setAudienceInEditionId', 'setFormula']),

        // Methods
        closeModal() {
            this.processing = false
            this.closeAudienceForm()
        },

        getCriterion(criterion) {
            if (this.mode === 'cclone') return criterion.criterion
            return criterion
        },

        // Tabs
        setTab(selectedTab) {
            this.setActiveTabFormAudience({ tab: selectedTab })
        },

        // Transfer
        callTransferForm() {
            this.setTab('audienceTransfer')
            if (this.totalTransfers === 0) this.newTransfer()
            else this.setShowFormCreateTransfer({ show: false })
        },

        newTransfer() {
            this.setShowFormCreateTransfer({ show: true })
        },

        editTransfer(transfer) {
            //remove transferInEdition from store to avoid duplication
            this.setTransferForm({
                action: 'remove',
                techno: transfer.technology,
                transfer
            })

            this.setTransferInEdition({ transfer })
            this.setActiveTabFormAudience({ tab: 'audienceTransfer' })
            this.setShowFormCreateTransfer({ show: true })
            this.setIsEditTransfer({ isEdit: true })
        },

        removeTransfer(transfer, techno) {
            this.setTransferForm({ action: 'remove', techno, transfer })
        },

        closeModalTransfer() {
            this.setActiveTabFormAudience({ tab: 'audienceDetails' })
        },

        // Volume Alert
        displayVolumeAlert() {
            this.setTab('volumeAlert')

            if (this.hasVolumeAlert) {
                this.setIsEditVolumeAlert({ isEdit: true })
            }
            this.setShowVolumeAlertForm({ show: true })
        },

        deleteVolumeAlert() {
            this.setDefaultVolumeAlertForm()
        },

        // CC
        updateFormCcList(ccList) {
            this.audienceForm.ccList = ccList
        },

        // Tags
        debounceLoadTags: debounce(function(tag, e) {
            if (e.keyCode === 40 || e.keyCode === 38) {
                // 40 down, 38 up
                return false
            }
            this.loadTags(tag)
        }, 200),

        loadTags(tag) {
            this.requestAccountTags(tag).then(response => {
                const apiResponse = response.map(tag => tag.label).sort()
                const exactMatching = filter(apiResponse, specialTag => specialTag.startsWith(tag))
                const formattedArray = uniq(exactMatching.concat(apiResponse))

                if (tag && tag.length >= 2) {
                    this.tagSuggestionList = isEmpty(this.tagList) ? formattedArray : difference(formattedArray, this.tagList)
                }
            })

            // Close the tag suggestion list
            if (this.inputTagValue.length === 0) this.tagSuggestionList = []
        },

        addTagSuggestion(tag) {
            this.tagList.push(tag)

            // Reset
            this.resetAutoCompleteTag()
        },

        handleInputTagConfirm() {
            if (!this.creatingTag) {
                this.creatingTag = true
                if (!isEmpty(this.tagSuggestionList) && !isNil(this.cmpTagListCurrentLabel)) {
                    // Select tag via keyboard navigation in autocomplete suggestion list
                    this.tagList.push(this.cmpTagListCurrentLabel)
                } else {
                    const arrayTagToAdd = uniq(this.inputTagValue.split(/[\s,;\t\n]+/))

                    // To avoid add empty tag
                    if (last(arrayTagToAdd) === '') return false

                    if (!validateTags(arrayTagToAdd)) {
                        this.setAddedNotification({
                            type: 'error',
                            message: 'Please do not use any special characters'
                        })
                        return false
                    }

                    // Add tag one by one or by list
                    if ((size(arrayTagToAdd) === 1 && this.fields.tag.valid) || size(arrayTagToAdd) > 1) {
                        this.tagList = uniq(this.tagList.concat(arrayTagToAdd))
                            .slice(0, this.maxTagsLimit)
                            .reverse()
                    }
                }
            }
            // Reset
            this.resetAutoCompleteTag()
        },

        resetAutoCompleteTag() {
            this.selectedSuggestionTags = []
            this.inputTagValue = ''
            this.tagListCurrentIndex = -1
            this.creatingTag = false
        },

        navigateAutoComplete(direction) {
            const maxIndex = size(this.tagSuggestionList) - 1

            if (direction === 1) {
                //down
                if (this.tagListCurrentIndex === -1) {
                    this.tagListCurrentIndex = 0 //case first tag
                } else if (this.tagListCurrentIndex < maxIndex) {
                    this.tagListCurrentIndex += direction //next element
                    document.getElementsByClassName('autocomplete-list')[0].scrollTop += 25 //manage scrolling
                }
            } else if (direction === -1) {
                //up
                if (this.tagListCurrentIndex > 0) {
                    this.tagListCurrentIndex += direction //next element
                    document.getElementsByClassName('autocomplete-list')[0].scrollTop -= 25 //manage scrolling
                }
            }
        },

        closeAutoComplete() {
            this.tagListCurrentIndex = -1
            this.tagSuggestionList = []
        },

        removeTag(tag) {
            this.tagList = filter(this.tagList, item => item !== tag)
        },

        // Audience
        saveAudience() {
            if (this.processing) return // Prevent multiple creation
            this.processing = true
            this.$validator.validateAll().then(isValid => {
                if (isValid) {
                    if (this.hasDisabledCriterion) {
                        this.$msgbox
                            .confirm('Your audience contains disabled elements. Disabled elements will not be saved as part of the audience.', 'Warning', {
                                type: 'warning',
                                confirmButtonText: 'OK',
                                cancelButtonText: 'Cancel'
                            })
                            .then(async () => {
                                await this.callRequestSaveAudience()
                                this.retrieveExpiringAudiences()
                                this.retrieveExpiringTransfers()
                            })
                            .catch(() => {
                                this.processing = false
                            })
                            .finally(() => {
                                this.creatingTag = false
                            })
                    } else {
                        this.callRequestSaveAudience().finally(() => {
                            this.creatingTag = false
                        })
                    }
                } else {
                    this.processing = false
                }

            })
        },

        callRequestSaveAudience() {
            let audienceParams = {
                label: this.audienceForm.label,
                country: this.countryCode2,
                audience_type: this.mode === 'segment' ? 'Custom' : 'Cclones',
                account_id: this.accountId,
                user: this.audienceForm.email,
                description: this.mode === 'segment' ? 'segmentFormula' : this.audienceForm.label,
                generic_formula: this.mode === 'segment' ? this.audienceFormula.v1 : this.ccloneFormula,
                user_id: get(Vue.prototype.$keycloak, 'tokenParsed.portal_id', 0),
                end_date: dayjs(this.audienceForm.endDate).format('YYYY-MM-DD'),
                bigsea: 'YES',
                bootstrap: this.bootstrapActivation === 'yes' ? 'attribute' : 'none',
                bootstrap_period: this.audienceForm.bootstrapPeriodSelected,
                email: this.audienceForm.email,
                email_cc: join(this.audienceForm.ccList, ',')
            }

            if (this.mode === 'cclone') {
                audienceParams = {
                    ...audienceParams,
                    strong_classifiers_family_id: this.selectedCcloneId
                }
            }

            if (this.hasVolumeAlert) {
                audienceParams = {
                    ...audienceParams,
                    email_audience_limit: this.volumeAlertForm.email_audience_limit,
                    email_cc_audience_limit: this.volumeAlertForm.email_cc_audience_limit.join(',')
                }
                if (!isNil(this.volumeAlertForm.above_limit) && this.volumeAlertForm.above_limit !== '') {
                    audienceParams = {
                        ...audienceParams,
                        above_limit: this.volumeAlertForm.above_limit
                    }
                }
                if (!isNil(this.volumeAlertForm.below_limit) && this.volumeAlertForm.below_limit !== '') {
                    audienceParams = {
                        ...audienceParams,
                        below_limit: this.volumeAlertForm.below_limit
                    }
                }
            }

            if (this.actionFormAudience === 'create') {
                this.createAudience(audienceParams)
                    .then(audience => {
                        // Empty the builder's formulas after the audience was created
                        if (this.totalTransfers === 0) {
                            this.exitEditAudience()
                            this.closeModal()
                            this.resetFormula()
                            this.retrieveExpiringAudiences()
                            this.retrieveExpiringTransfers()
                        }

                        // Send tags to API
                        this.saveTags(audience)

                        // Send transfers to API
                        if (audience && this.totalTransfers > 0) {
                            const mediaTransfers = reduce(
                                this.transferForms['technology-media'],
                                (memo, mediaTypeValue) => {
                                    return [...memo, formatTransferParams(audience, mediaTypeValue, 'media')]
                                },
                                []
                            )
                            const pixelTransfers = reduce(
                                this.transferForms['technology-pixel'],
                                (memo, pixelTypeValue) => {
                                    return [...memo, formatTransferParams(audience, pixelTypeValue, 'pixel')]
                                },
                                []
                            )
                            const transferParams = {
                                data_transfers: concat([], mediaTransfers, pixelTransfers),
                                audienceId: audience.id,
                                editAudience: false
                            }
                            this.createTransfer(transferParams)
                            this.exitEditAudience()
                            this.closeModal()
                            this.resetFormula()
                            this.retrieveExpiringAudiences()
                            this.retrieveExpiringTransfers()
                        } else {
                            return false
                        }
                    })
                    .catch(err => errorHandler(err, this.$store.commit))
            }

            if (this.actionFormAudience === 'edit') {
                const audienceBeforeEdition = { ...this.audienceInEdition }
                audienceParams.id = this.audienceInEdition.id
                if (this.audienceInEdition.bootstrap !== 'none') audienceParams.bootstrap = this.audienceInEdition.bootstrap
                this.editAudience({
                    id: this.audienceInEdition.id,
                    params: audienceParams,
                    notificationMessage: 'Audience successfully updated',
                    tags: this.tagList
                })
                    .then(() => {
                        this.saveTags(this.audienceInEdition)
                        this.removeTags(audienceBeforeEdition)
                        this.exitEditAudience()
                        this.closeModal()
                        this.resetFormula()
                        this.retrieveExpiringAudiences()
                        this.retrieveExpiringTransfers()
                    })
                    .catch(err => errorHandler(err, this.$store.commit))
            }

            return Promise.resolve()
        },

        exitEditAudience() {
            this.setAudienceInEditionId(undefined)
        },

        resetFormula() {
            if (!isEmpty(this.formula)) {
                this.formula.setRecency(30)
                this.formula.setQuantile(10)
                this.formula.setSurfIntensity(0)
                this.setFormula(this.formula)
                this.formula && this.formula.initializeFormula()
            }
        },

        saveTags(audience) {
            if (this.launchTagsCreation && audience) {
                const tagsParams = {
                    id: audience.id,
                    account_id: this.accountId,
                    tags: JSON.stringify(this.tagList)
                }
                this.addNewAudienceTags(tagsParams).then(tags => {
                    // retrieve audiences from base to keep store updated (single source of truth)
                    if (!isEmpty(tags)) {
                        this.retrieveItems()
                    }
                })
            }
        },

        removeTags(audienceBeforeEdition) {
            const tagsToRemove = audienceBeforeEdition?.tags?.filter(tag => !this.tagList.includes(tag.label)) || []

            tagsToRemove.forEach(tag => {
                this.deleteTagFromAudience({
                    audience: this.audienceInEdition,
                    tagId: tag.id,
                    update: false
                })
            })
        },

        settingTitleHint(type, value) {
            return `${type}: ${value}`
        },

        handleResetFieldOnLeave(field) {
            if (field === 'endDate' && this.errors.has('end_date') && this.actionFormAudience !== 'edit')
                this.audienceForm.endDate = this.audienceFormHistory.endDate
            else if (field === 'email' && this.errors.has('email')) this.audienceForm.email = this.audienceFormHistory.email
        }
    }
}
</script>
